<template>
    <div  class="image round loader">
    </div>
</template>

<script>
export default {
 name:"ImageLoader",
}
</script>

<style lang="scss" scoped>
.image{
  width: 50%;
  padding-bottom:50% ;
  min-width: 150px;
  margin: auto;
  height: auto;
  max-width: 300px;
  box-shadow: 0 5px 10px #00000030; 
}
.image img{
  width: 100%;
  height:auto;
}
.round{
  border-radius: 50000px;
}

.loader {
  background: linear-gradient(115deg, #e7e7e7, #b8b8b8);
  background-size: 400% 400%;
  animation: Loading 1s ease infinite;
}

@keyframes Loading {
    0%{background-position:23% 0%}
    50%{background-position:78% 100%}
    100%{background-position:23% 0%}
}
</style>